import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param payload
 */
class IntegrationServices {
    /**
     * @param orgId
     * @param {*} payload
     * @return
     */
    getIntegrations = async (orgId) => {
      let url = `${Constants.INTEGRATIONS}`;
      if (orgId) url += `?org_id=${orgId}&`;

      const linkDaTallyData = await Helpers.get({
        url,
      });
      return linkDaTallyData;
    }
}
export default new IntegrationServices();
